export enum IngestionType {
  ZOOM_INGESTION = 'ZoomIngestion',
  ZOOM_INGESTION_PENDING = 'ZoomIngestionPending',
}
